import { render, staticRenderFns } from "./CompanyLeftSection.vue?vue&type=template&id=bfbecbe4&scoped=true"
import script from "./CompanyLeftSection.vue?vue&type=script&lang=js"
export * from "./CompanyLeftSection.vue?vue&type=script&lang=js"
import style0 from "./CompanyLeftSection.vue?vue&type=style&index=0&id=bfbecbe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbecbe4",
  null
  
)

export default component.exports